<template>
  <div class="mobile-table-content">
    <div class="table-title">
      <div class="title-left"><i class="el-icon-s-management" />项目信息</div>
      <div class="title-right"></div>
    </div>
    <!-- 付款信息 -->
    <div class="list-content">
      <CommonDetail :listConfig="listConfig" :listData="listData">
      </CommonDetail>
    </div>

    <SelectDrawer ref="selectDrawer" @handleChangeData="handleChangeData" />
  </div>
</template>
<script>
import CommonDetail from "@/components/workflowComponents/mobile/commonDetail";
import TableDetail from "@/components/workflowComponents/mobile/tableDetail";
import { mapGetters } from "vuex";
import SelectInput from "@/components/commonSelect/selectInput";
import SelectDrawer from "@/components/workflowComponents/mobile/selectDrawer";

export default {
  name: "mobileApplyList",
  data() {
    return {
      tableData: [],
      tableDataAccounts: [{}],

      listConfig: [
        {
          label: "合同编号",
          prop: "contractNo",
        },
        {
          label: "所属项目",
          prop: "rdProjectVO",
          propInner: "name",
        },
        {
          label: "客户经理",
          prop: "rdProjectVO",
          propInner: "managerName",
        },
        {
          label: "银行或发债机构",
          prop: "rdProjectVO",
          propInner: "bankName",
        },
        {
          label: "担保额度",
          prop: "rdProjectVO",
          propInner: "quota",
          formatter: (label, value) => {
            return this.getMoney(value) + "元";
          },
        },
        {
          label: "担保类型",
          prop: "rdProjectVO",
          propInner: "guaranteeTypeText",
        },
        {
          label: "业务类型",
          prop: "rdProjectVO",
          propInner: "businessTypeText",
        },
        {
          label: "担保费率",
          prop: "loanRate",
          formatter: (label, value) => {
            return value + "%";
          },
        },
        {
          label: "担保期限",
          prop: "guaranteeStartDate",
      
          
        },
      ],
    };
  },
  components: {
    CommonDetail,
    TableDetail,
    SelectInput,
    SelectDrawer,
  },
  props: {
    listData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    flowData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    status: {
      type: String,
      default: "done",
    },
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  watch: {
    
  },
  methods: {
    
    handleChangeData(changeName, el) {
      this[changeName](el);
    },
  },
};
</script>
<style lang="scss" scoped>
.mobile-table-content {
  .table-title {
    width: 100%;
    height: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 1rem;
    margin-top: 0.2rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
    .title-left {
      font-size: .38rem;
      color: #666;
      font-weight: 600;
    }
    .title-right {
      font-size: .38rem;
      color: #ccc;
    }
  }
  .list-content {
    .info-one {
      background-color: #fff;
      border-top: 0.5px solid #f2f2f2;
      border-bottom: 0.5px solid #f2f2f2;
      padding-left: 0.3rem;
      padding-right: 0.3rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 1.2rem;
      padding-top: 0.15rem;
      padding-bottom: 0.15rem;
      .info-left {
        width: 30%;
        color: #999;
        font-size: .38rem;
      }
      .info-right {
        width: 65%;
        font-size: .38rem;
        text-align: right;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        // white-space: nowrap;
      }
    }
  }
  .item-one {
    background-color: #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
    width: 100%;
    padding: 0.35rem 0.4rem;
    border-radius: 0.2rem;
    margin-bottom: 0.2rem;
    .item-index {
      font-size: .38rem;
      line-height: 0.7rem;
      color: #999;
      font-weight: 600;
    }
    .item-line {
      font-size: .38rem;
      line-height: 0.55rem;
      color: #999;
      span {
        margin-left: 0.3rem;
      }
    }
    .remark-content {
      font-size: .38rem;
      color: #333;
      line-height: 0.7rem;
    }
  }
}
.info_right_edit {
  color: #409eff !important;
  cursor: pointer !important;
}
/deep/.van-cell {
  padding-right: 0 !important;
}
</style>